import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'isAvatarImage',
  pure: true // This makes it a pure pipe for better performance
})
export class IsAvatarImagePipe implements PipeTransform {
  transform(avatar: string): boolean {
    if (!avatar) {
      return false;
    }
    
    return avatar.includes('.jpg') || 
           avatar.includes('.png') || 
           avatar.includes('.jpeg') || 
           avatar.includes('assets/');
  }
}
